const countryList = [
  {
    nameKey: "Asia",
    child: [
      {
        nameKey: "Singapore",
        key: "Singapore",
      },

      {
        nameKey: "Indonesia",
        key: "Indonesia",
      },
      // {
      //   nameKey: "India",
      //   key: "India",
      // },
      {
        nameKey: "Cambodia",
        key: "Cambodia",
      },
      {
        nameKey: "Vietnam",
        key: "Vietnam",
      },
    ],
  },
  //   {
  //     name: "Europe",
  //     child: [],
  //   },
];

export default countryList;
